import { Box, styled } from '@material-ui/core'

const ColorRoute = styled(Box)(({ colorRoute }: { colorRoute: string }) => ({
  backgroundColor: colorRoute,
  width: '12px',
  height: '65px',
}))

export default ColorRoute
